import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { glacierPolicyApiGetPolicyPermissionsOptions } from '../heyapi/@tanstack/react-query.gen';

// Custom hook to handle editMode and isTravelTime
export const useEditMode = (policyId: string | undefined) => {
  const [editMode, setEditMode] = useState<boolean>(true);
  const [isTravelTime, setIsTravelTime] = useState<boolean>(false);

  const { data: permissionsData } = useQuery({
    enabled: policyId !== undefined,
    ...glacierPolicyApiGetPolicyPermissionsOptions({
      path: {
        account_id: policyId!,
      },
    }),
  });

  useEffect(() => {
    const hasSequenceId = sessionStorage.getItem('sequence_id');
    if (hasSequenceId) {
      setEditMode(false);
      setIsTravelTime(true);
      return;
    }

    // No sequence_id = no time travel mode
    setIsTravelTime(false);

    if (
      permissionsData &&
      (permissionsData === 'READ' || permissionsData === 'UNAUTHORIZED')
    ) {
      setEditMode(false);
    }
    if (permissionsData && permissionsData === 'WRITE') {
      setEditMode(true);
    }

    // TODO: Add block if unauthorized & reroute to main screen
  }, [permissionsData]);

  return {
    editMode,
    setEditMode,
    isTravelTime,
    setIsTravelTime,
  };
};
